// Definice modulů V-Mart Tools — sjednocené pro frontend.
// Backend má vlastní kopii v api/lib/modules.ts (Cloudflare Workers
// nemůže importovat z /src). Hodnoty MUSÍ být ekvivalentní.

export const MODULE_IDS = [
  'products_db',
  'orders_db',
  'propojeni',
  'sady',
  'analytics',
  'odpocty',
  'upsell',
  'produkt_tydne',
  'razeni_kategorii',
  'skladove_zasoby',
  'sklad_sync',
  'watchdog',
  'sales_history',
  'automatizace_objednavek',
  'rozdily_skladu',
  'recenze_sync',
  'vyroba',
  // Výroba se povoluje po jednotlivých položkách menu.
  'vyroba_zakazky',
  'vyroba_terminy',
  'vyroba_plan_strihani',
  'vyroba_sklad_latek',
  'vyroba_info_latka',
  'vyroba_kontrola_napletu',
  'vyroba_kontrola_latek',
  'vyroba_delka_zakazek',
  'vyroba_druha_jakost',
  'vyroba_vyskladneni',
  'vyroba_na_zakazku',
  'vyroba_prijem',
  'vyroba_objednavky',
  'vyroba_sklad_materialu',
  'vyroba_nakup',
  'vyroba_externi_vera',
  'vyroba_sici',
  'vyroba_vykazy',
  'vyroba_dilna_plan',
  'vyroba_chybovost',
  'vyroba_zadani',
  'vyroba_naskladneni',
  'vyroba_eshopy',
  'vyroba_statistiky',
  'vyroba_trideni_na_zakazku',
  'vyroba_log_objednavek',
  'vyroba_automatizace',
  'vyroba_pozadavky',
  'vyroba_formulare',
  'vyroba_zdroje_kategorie',
  'vyroba_zdroje_niti',
  'vyroba_zdroje_zipy',
  'vyroba_zdroje_latky',
  'vyroba_zdroje_produkty',
  'vyroba_zdroje_napletu',
  'vyroba_zdroje_svadlenky',
  'vyroba_zdroje_normy',
  'user_admin',
] as const;

export type ModuleId = (typeof MODULE_IDS)[number];

export const MODULE_LABELS: Record<ModuleId, string> = {
  products_db: 'Databáze produktů',
  orders_db: 'Databáze objednávek',
  propojeni: 'Propojení produktů',
  sady: 'Produktové sady',
  analytics: 'Analytics',
  odpocty: 'Odpočty',
  upsell: 'Upsell & Cross-sell',
  produkt_tydne: 'Produkt týdne',
  razeni_kategorii: 'Řazení v kategoriích',
  skladove_zasoby: 'Skladové zásoby',
  sklad_sync: 'Sklad-sync',
  watchdog: 'Hlídací pes',
  sales_history: 'Analýza historie prodeje',
  automatizace_objednavek: 'Automatizace objednávek',
  rozdily_skladu: 'Rozdíly skladů',
  recenze_sync: 'Sync recenzí CZ ↔ SK',
  vyroba: 'Výroba',
  vyroba_zakazky: 'Výroba (zakázky)',
  vyroba_terminy: 'Termíny výroby',
  vyroba_plan_strihani: 'Plán stříhání',
  vyroba_sklad_latek: 'Sklad látek',
  vyroba_info_latka: 'Informace o látce',
  vyroba_kontrola_napletu: 'Kontrola nápletu',
  vyroba_kontrola_latek: 'Kontrola látek',
  vyroba_delka_zakazek: 'Délka zakázek švadlen',
  vyroba_druha_jakost: '2. jakost',
  vyroba_vyskladneni: 'Vyskladnění z výroby',
  vyroba_na_zakazku: 'Šití na zakázku',
  vyroba_prijem: 'Příjem materiálu',
  vyroba_objednavky: 'Objednávky materiálu',
  vyroba_sklad_materialu: 'Sklad drobného materiálu',
  vyroba_nakup: 'Přehled nákupu (zvoneček)',
  vyroba_externi_vera: 'Věra Martínková',
  vyroba_sici: 'Výroba (čtečka)',
  vyroba_vykazy: 'Výkazy',
  vyroba_dilna_plan: 'Plán dokončovací dílny',
  vyroba_chybovost: 'Chybovost švadlen',
  vyroba_zadani: 'Zadání do výroby',
  vyroba_naskladneni: 'Naskladnění z výroby',
  vyroba_eshopy: 'Napojení e-shopů',
  vyroba_statistiky: 'Statistiky',
  vyroba_trideni_na_zakazku: 'Třídění objednávek na zakázku',
  vyroba_log_objednavek: 'Log automatizace objednávek',
  vyroba_automatizace: 'Automatizace',
  vyroba_pozadavky: 'Nová objednávka',
  vyroba_formulare: 'Formuláře',
  vyroba_zdroje_kategorie: 'Databáze kategorií',
  vyroba_zdroje_niti: 'Databáze nití',
  vyroba_zdroje_zipy: 'Databáze zipů',
  vyroba_zdroje_latky: 'Databáze látek',
  vyroba_zdroje_produkty: 'Databáze produktů (výroba)',
  vyroba_zdroje_napletu: 'Databáze nápletů',
  vyroba_zdroje_svadlenky: 'Databáze švadlenek',
  vyroba_zdroje_normy: 'Normy švadlenek',
  user_admin: 'Správa uživatelů',
};

export const MODULE_DESCRIPTIONS: Partial<Record<ModuleId, string>> = {
  products_db: 'Přehled produktů z marketing feedu Shoptetu.',
  orders_db: 'Databáze objednávek (sync z Shoptetu).',
  propojeni: 'Propojení produktů do skupin.',
  sady: 'Dárkové/výhodné sady produktů s variantami — slevový kupón napojený na komponenty.',
  analytics: 'GA4 analytics — KPIs, funnel, zdroje.',
  odpocty: 'Odpočty času (GIF + JS widget) pro e-shop.',
  upsell: 'Bannery a cross-sell nabídky na e-shopu.',
  produkt_tydne: 'Týdenní akce — vybrané produkty se slevou a vyšší prioritou.',
  razeni_kategorii: 'Pořadí produktů v kategoriích e-shopu přetažením (Shoptet priorita).',
  skladove_zasoby: 'Hodnota skladu po kategoriích v prodejních cenách bez DPH.',
  sklad_sync: 'Denní sync skladů (Shoptet ↔ Brani ↔ Výroba).',
  watchdog: 'Hlídací pes — notifikace zákazníků o vyprodaných variantách + měření přínosu.',
  sales_history: 'Historie prodejů po měsících — TOP produkty, Pareto, stockouty.',
  automatizace_objednavek:
    'Přehled pravidel, podle kterých se u CZ a SK e-shopu automaticky přepínají stavy objednávek.',
  rozdily_skladu: 'Kontrola nesrovnalostí mezi e-shopy a skladem (zatím CZ vs. SK skladovost).',
  recenze_sync: 'Kopírování schválených recenzí produktů mezi CZ a SK e-shopem.',
  vyroba: 'Přístup do výrobního systému. Jednotlivé obrazovky se povolují níže.',
  vyroba_zakazky: 'Seznam výrobních zakázek, jejich zakládání, tisk A6 listu a naskladnění.',
  vyroba_terminy: 'Termíny výroby a jejich propsání do e-shopů.',
  vyroba_plan_strihani: 'Co nastříhat k termínu, priority, poznámky a timeline švadlenek.',
  vyroba_sklad_latek: 'Role látek na skladě a jejich vyskladňování.',
  vyroba_info_latka: 'Co se z látky šije, skladovost velikostí v e-shopu a kolik látky máme.',
  vyroba_kontrola_napletu: 'Kolik metrů které barvy nápletu potřebujeme na to, co zbývá nastříhat.',
  vyroba_kontrola_latek:
    'Kolik metrů hlavních látek potřebujeme na to, co zbývá nastříhat, a kolik jich chybí na skladě.',
  vyroba_delka_zakazek: 'Jak dlouhé zakázky (podle normy) dostávají jednotlivé švadlenky.',
  vyroba_druha_jakost: 'Založení 2. jakosti z originálního produktu (kopie s novým kódem).',
  vyroba_vyskladneni: 'Odepsání kusů z výroby, když se dávka ruší nebo se spletlo zadání.',
  vyroba_na_zakazku: 'Kolik vyprodaných velikostí bychom uměli ušít z látky, co leží na dílně.',
  vyroba_prijem: 'Příjem materiálu na sklad.',
  vyroba_objednavky: 'Objednávky materiálu u dodavatelů.',
  vyroba_sklad_materialu: 'Zipy, knoflíky a další drobný materiál — stav, minimum, výdej.',
  vyroba_externi_vera:
    'Externí dílna: rozpracované zakázky švadlenky „Mamka" (jen ke čtení). Externímu účtu dej jen tohle a „Výroba".',
  vyroba_nakup:
    'Dashboard všeho, co je potřeba objednat (požadavky dílny + chybějící zipy), a zvoneček s počtem v horní liště.',
  vyroba_sici: 'Obrazovka pro čtečku — START/KONEC šití zakázky.',
  vyroba_vykazy: 'Měsíční výkazy práce švadlen včetně PDF.',
  vyroba_dilna_plan: 'Co je předskladněné k jednotlivým termínům.',
  vyroba_chybovost: 'Evidence vadných kusů po švadlenkách.',
  vyroba_zadani: 'Zadávání kusů do výroby na termín.',
  vyroba_naskladneni: 'Naskladnění hotových kusů z výroby na skladovou pozici.',
  vyroba_eshopy: 'Napojení e-shopů (dostupnosti a stavy objednávek).',
  vyroba_statistiky: 'Hodnota vyrobeného zboží a další čísla o výrobě.',
  vyroba_trideni_na_zakazku:
    'Náhled objednávek ve stavu „Ušijeme do X dní" (CZ i SK) a do kterého termínu by se měly zařadit.',
  vyroba_log_objednavek: 'Historie automatu, který přepíná došité předobjednávky do „Vyřizuje se".',
  vyroba_automatizace:
    'Úklid propadlých termínových dostupností v Shoptetu (CZ i SK) — živě přes API, s ručním tlačítkem i nočním cronem.',
  vyroba_pozadavky:
    'Nástěnka požadavků dílny — co je potřeba objednat (materiál, spotřebka, drobnosti).',
  vyroba_formulare: 'Odkazy na sdílené formuláře dílny (Google Docs / Sheets).',
  user_admin: 'Správa uživatelů a jejich oprávnění (de-facto super-admin).',
};

/** Uzel stromu oprávnění. Skupina (bez `id`) jen sdružuje položky pod sebou. */
export type ModuleNode = {
  id?: ModuleId;
  label: string;
  children?: ModuleNode[];
};

/**
 * Strom oprávnění tak, jak vypadá menu — každá položka se povoluje zvlášť.
 * Skupiny („Střihárna", „Zdroje") vlastní modul nemají, jen se přes ně dá
 * zaškrtnout celá sekce najednou.
 */
export const MODULE_TREE: ModuleNode[] = [
  { id: 'products_db', label: MODULE_LABELS.products_db },
  { id: 'orders_db', label: MODULE_LABELS.orders_db },
  { id: 'propojeni', label: MODULE_LABELS.propojeni },
  { id: 'analytics', label: MODULE_LABELS.analytics },
  { id: 'odpocty', label: MODULE_LABELS.odpocty },
  { id: 'upsell', label: MODULE_LABELS.upsell },
  { id: 'produkt_tydne', label: MODULE_LABELS.produkt_tydne },
  { id: 'razeni_kategorii', label: MODULE_LABELS.razeni_kategorii },
  { id: 'skladove_zasoby', label: MODULE_LABELS.skladove_zasoby },
  { id: 'sklad_sync', label: MODULE_LABELS.sklad_sync },
  { id: 'watchdog', label: MODULE_LABELS.watchdog },
  { id: 'sales_history', label: MODULE_LABELS.sales_history },
  { id: 'automatizace_objednavek', label: MODULE_LABELS.automatizace_objednavek },
  { id: 'rozdily_skladu', label: MODULE_LABELS.rozdily_skladu },
  { id: 'recenze_sync', label: MODULE_LABELS.recenze_sync },
  {
    id: 'vyroba',
    label: MODULE_LABELS.vyroba,
    children: [
      { id: 'vyroba_zakazky', label: MODULE_LABELS.vyroba_zakazky },
      { id: 'vyroba_terminy', label: MODULE_LABELS.vyroba_terminy },
      { id: 'vyroba_zadani', label: MODULE_LABELS.vyroba_zadani },
      { id: 'vyroba_vyskladneni', label: MODULE_LABELS.vyroba_vyskladneni },
      { id: 'vyroba_na_zakazku', label: MODULE_LABELS.vyroba_na_zakazku },
      { id: 'vyroba_statistiky', label: MODULE_LABELS.vyroba_statistiky },
      { id: 'vyroba_trideni_na_zakazku', label: MODULE_LABELS.vyroba_trideni_na_zakazku },
      { id: 'vyroba_log_objednavek', label: MODULE_LABELS.vyroba_log_objednavek },
      { id: 'vyroba_automatizace', label: MODULE_LABELS.vyroba_automatizace },
      { id: 'vyroba_druha_jakost', label: MODULE_LABELS.vyroba_druha_jakost },
      {
        label: 'Střihárna',
        children: [
          { id: 'vyroba_plan_strihani', label: MODULE_LABELS.vyroba_plan_strihani },
          { id: 'vyroba_sklad_latek', label: MODULE_LABELS.vyroba_sklad_latek },
          { id: 'vyroba_info_latka', label: MODULE_LABELS.vyroba_info_latka },
          { id: 'vyroba_kontrola_napletu', label: MODULE_LABELS.vyroba_kontrola_napletu },
          { id: 'vyroba_kontrola_latek', label: MODULE_LABELS.vyroba_kontrola_latek },
          { id: 'vyroba_delka_zakazek', label: MODULE_LABELS.vyroba_delka_zakazek },
        ],
      },
      {
        label: 'Nákup',
        children: [
          { id: 'vyroba_prijem', label: MODULE_LABELS.vyroba_prijem },
          { id: 'vyroba_objednavky', label: MODULE_LABELS.vyroba_objednavky },
          { id: 'vyroba_sklad_materialu', label: MODULE_LABELS.vyroba_sklad_materialu },
          { id: 'vyroba_nakup', label: MODULE_LABELS.vyroba_nakup },
        ],
      },
      {
        label: 'Externí dílny',
        children: [{ id: 'vyroba_externi_vera', label: MODULE_LABELS.vyroba_externi_vera }],
      },
      {
        label: 'Šicí dílna',
        children: [
          { id: 'vyroba_sici', label: MODULE_LABELS.vyroba_sici },
          { id: 'vyroba_vykazy', label: MODULE_LABELS.vyroba_vykazy },
        ],
      },
      {
        label: 'Dokončovací dílna',
        children: [
          { id: 'vyroba_dilna_plan', label: MODULE_LABELS.vyroba_dilna_plan },
          { id: 'vyroba_naskladneni', label: MODULE_LABELS.vyroba_naskladneni },
          { id: 'vyroba_chybovost', label: MODULE_LABELS.vyroba_chybovost },
        ],
      },
      { id: 'vyroba_pozadavky', label: MODULE_LABELS.vyroba_pozadavky },
      { id: 'vyroba_formulare', label: MODULE_LABELS.vyroba_formulare },
      { id: 'vyroba_eshopy', label: MODULE_LABELS.vyroba_eshopy },
      {
        label: 'Zdroje',
        children: [
          { id: 'vyroba_zdroje_kategorie', label: MODULE_LABELS.vyroba_zdroje_kategorie },
          { id: 'vyroba_zdroje_niti', label: MODULE_LABELS.vyroba_zdroje_niti },
          { id: 'vyroba_zdroje_zipy', label: MODULE_LABELS.vyroba_zdroje_zipy },
          { id: 'vyroba_zdroje_latky', label: MODULE_LABELS.vyroba_zdroje_latky },
          { id: 'vyroba_zdroje_produkty', label: MODULE_LABELS.vyroba_zdroje_produkty },
          { id: 'vyroba_zdroje_napletu', label: MODULE_LABELS.vyroba_zdroje_napletu },
          { id: 'vyroba_zdroje_svadlenky', label: MODULE_LABELS.vyroba_zdroje_svadlenky },
          { id: 'vyroba_zdroje_normy', label: MODULE_LABELS.vyroba_zdroje_normy },
        ],
      },
    ],
  },
  { id: 'user_admin', label: MODULE_LABELS.user_admin },
];

/** Všechna id pod uzlem (včetně jeho vlastního) — pro hromadné zaškrtnutí. */
export function moduleIdsOf(node: ModuleNode): ModuleId[] {
  const out: ModuleId[] = node.id ? [node.id] : [];
  for (const child of node.children ?? []) out.push(...moduleIdsOf(child));
  return out;
}

export function hasModule(modules: readonly string[] | undefined, target: ModuleId): boolean {
  return !!modules && modules.includes(target);
}

/** Má uživatel aspoň jeden z modulů? (Sekce menu se ukáže kvůli kterémukoli.) */
export function hasAnyModule(
  modules: readonly string[] | undefined,
  ...targets: ModuleId[]
): boolean {
  return !!modules && targets.some((t) => modules.includes(t));
}
